/* eslint-disable import/no-unresolved */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { useFormik, Form, FormikProvider } from 'formik';
import closeFill from '@iconify/icons-eva/close-fill';
import { Icon } from '@iconify/react';
// material
import {
  Stack,
  Alert,
  Checkbox,
  TextField,
  FormControlLabel,
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { styled } from '@mui/material/styles';
import {
  getUserName,
  getPassword,
  getAccessToken,
  getMerchantId,
  getUser,
} from '../../../redux/slice/user';
import { setPermitMerchantId } from '../../../redux/slice/merchant';
import useIsMountedRef from '../../../hooks/useIsMountedRef';
import useAuth from '../../../hooks/useAuth';
import { MIconButton } from '../../@material-extend';
// import { ROOTS_DASHBOARD } from '../../../routes/paths';

const FieldText = styled(TextField)({
  background: '#F4F4F4',
  width: '231px',
});

export default function LoginForm(props) {
  const dispatch = useDispatch();
  const { login, getProfile, forceLogout, setMerchantId } = useAuth();
  const navigate = useNavigate();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const isMountedRef = useIsMountedRef();
  const { cut } = props;

  const [showPassword, setShowPassword] = useState(false);

  const { t } = useTranslation('login');

  const LoginSchema = Yup.object().shape({
    username: Yup.string().required('Email is required'),
    password: Yup.string().required('Password is required'),
  });

  const formik = useFormik({
    initialValues: {
      username: '',
      password: '',
      remember: false,
    },
    validationSchema: LoginSchema,
    onSubmit: (values, { setErrors, setSubmitting, resetForm }) => {
      try {
        login(values.username, values.password)
          .then(async (res) => {
            const response = await getProfile(res);

            // 將用戶的信息放入 redux
            try {
              if (response.token) {
                const merchantId = response.staff[0].merchant_id;
                await setMerchantId(merchantId);
                dispatch(setPermitMerchantId(merchantId));
                localStorage.setItem('merchant_id', merchantId);
                dispatch({ type: 'connection/connect' });
                dispatch(getUserName(values.username));
                dispatch(getPassword(values.password));
                dispatch(getAccessToken(res));
                dispatch(getMerchantId(merchantId));
                dispatch(getUser(response));
                // 登陆成功后切换选择阶段页面
                cut();
                // navigate(ROOTS_DASHBOARD);
                enqueueSnackbar(t('logSuccess'), {
                  variant: 'success',
                  anchorOrigin: {
                    horizontal: 'center',
                    vertical: 'top',
                  },
                  // eslint-disable-next-line react/no-unstable-nested-components
                  action: (key) => (
                    <MIconButton
                      size="small"
                      onClick={() => closeSnackbar(key)}
                    >
                      <Icon icon={closeFill} />
                    </MIconButton>
                  ),
                });
                return response;
              }
              throw TypeError('invalid response token');
            } catch (error) {
              await forceLogout();
              enqueueSnackbar(t(`logError.${res.result}`), {
                variant: 'error',
                anchorOrigin: { horizontal: 'center', vertical: 'top' },
                // eslint-disable-next-line react/no-unstable-nested-components
                action: (key) => (
                  <MIconButton size="small" onClick={() => closeSnackbar(key)}>
                    <Icon icon={closeFill} />
                  </MIconButton>
                ),
              });
              navigate('/login');
              window.localStorage.removeItem('accessToken');
              window.localStorage.removeItem('uuid');
            }
            return false;
          })
          .catch((err) => {
            console.log(err);
            enqueueSnackbar(t('logError.200'), {
              variant: 'error',
              anchorOrigin: { horizontal: 'center', vertical: 'top' },
              // eslint-disable-next-line react/no-unstable-nested-components
              action: (key) => (
                <MIconButton size="small" onClick={() => closeSnackbar(key)}>
                  <Icon icon={closeFill} />
                </MIconButton>
              ),
            });
            navigate('/login');
          })
          .finally(() => {
            if (isMountedRef.current) {
              setSubmitting(false);
            }
          });
      } catch (error) {
        resetForm();
        if (isMountedRef.current) {
          setSubmitting(false);
          setErrors({ afterSubmit: error.message });
        }
      }
    },
  });

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } =
    formik;

  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };

  return (
    <FormikProvider value={formik}>
      <Form
        style={{ width: '100%' }}
        autoComplete="off"
        noValidate
        onSubmit={handleSubmit}
      >
        <Stack spacing={3}>
          {errors.afterSubmit && (
            <Alert severity="error">{errors.afterSubmit}</Alert>
          )}

          <FieldText
            fullWidth
            size="small"
            autoComplete="username"
            type="username"
            label={t('lable_username')}
            {...getFieldProps('username')}
            error={Boolean(touched.username && errors.username)}
          />

          <FieldText
            fullWidth
            size="small"
            sx={{
              mt: '16px !important',
            }}
            autoComplete="current-password"
            type={showPassword ? 'text' : 'password'}
            label={t('lable_psd')}
            {...getFieldProps('password')}
            error={Boolean(touched.password && errors.password)}
          />
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ mt: 2, mb: 2 }}
        >
          <FormControlLabel
            sx={{
              ml: 0,
              color: '#A3A3A3',
              '& .MuiFormControlLabel-label': {
                fontSize: '0.75rem',
                ml: '7px',
              },
            }}
            control={
              <Checkbox
                size="small"
                {...getFieldProps('remember')}
                checked={values.remember}
                sx={{ padding: '0px' }}
              />
            }
            label={t('lable_remeb_Me')}
          />
          {/* <span style={{ fontSize: '0.75rem', color: '#78AEFF' }}>
            {t('forgot_psd')}
          </span> */}
        </Stack>
        <LoadingButton
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          loading={isSubmitting}
          sx={{
            width: '229px',
            height: '37px',
            background: '#2C3181',
            marginLeft: '1px',
            ':hover': {
              backgroundColor: '#2C3181',
            },
          }}
        >
          {t('login_btn')}
        </LoadingButton>
      </Form>
    </FormikProvider>
  );
}

LoginForm.propTypes = {
  cut: PropTypes.func.isRequired,
};
